import { toPng } from "html-to-image";

const fetchImageAsBase64 = async (imageUrl: any) => {
    try {
        const response = await fetch(imageUrl, {
            mode: "cors",
            cache: "no-cache", // Force fresh fetch
        });
        const blob = await response.blob();

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error("Failed to fetch image:", imageUrl, error);
        return imageUrl; // Return original URL if fetching fails
    }
};

const replaceImagesWithBase64 = async (container: any) => {
    const imgElements = container.querySelectorAll("img");

    for (const img of imgElements) {
        if (!img.src.startsWith("data:image")) { // Avoid reprocessing base64 images
            const base64 = await fetchImageAsBase64(img.src);
            img.setAttribute("src", base64);
        }
    }
};

export const handleDownloadImage = async (divRef: any, name: string) => {
    if (!divRef.current) return;

    try {
        await replaceImagesWithBase64(divRef.current); // Ensure all images are converted

        // Convert div to an image after replacing all images
        const dataUrl = await toPng(divRef.current, { pixelRatio: 2 });

        // Convert dataURL to Blob
        const blob = await (await fetch(dataUrl)).blob();
        const file = new File([blob], `${name}.png`, { type: "image/png" });

        // Trigger download
        // const link = document.createElement("a");
        // link.href = URL.createObjectURL(blob);
        // link.download = file.name;
        // link.click();
        return file;
    } catch (error) {
        console.error("Failed to generate image:", error);
    }
};